import React, { Component } from "react";
import { Link } from "react-router-dom";

import IconSpinner from "../icons/spinner";
import IconButton from "../icons/button";

class Button extends Component {
    constructor(props) {
        super(props);

        this._onPress = this._onPress.bind(this);
    }

    _onPress() {
        const { onClick, isLoading, text, disable } = this.props;

        if (isLoading || disable) return null;

        if (onClick) onClick(text);
    }

    _renderLoading() {
        const { isLoading, backgroundColorOver, textStyle } = this.props;

        if (!isLoading) return null;

        let loadingClassName =
            "absolute inset-0 flex justify-center items-center z-10";

        loadingClassName += " " + backgroundColorOver;

        return (
            <div className={loadingClassName}>
                <IconSpinner
                    className={`animate-spin w-20 h-20 ${textStyle}`}
                />
            </div>
        );
    }

    _renderAnimation() {
        const { backgroundColorOver, disable } = this.props;

        if (disable) return null;

        let lineClassName = `absolute transition-all h-1/4 left-0 hover-hover:group-hover:w-full w-0 ${backgroundColorOver}`;

        return (
            <>
                <div className={lineClassName + " top-0 delay-0"} />
                <div className={lineClassName + " top-1/4 delay-50"} />
                <div className={lineClassName + " top-2/4 delay-100"} />
                <div className={lineClassName + " top-3/4 delay-150"} />
            </>
        );
    }

    render() {
        const {
            title,
            text,
            to,
            toTarget,
            href,
            url,
            target,
            height,
            style,
            wrapperStyle,
            comingSoon,
            icon,
            disable,
            backgroundColor,
            borderColor,
            textStyle,
            submit,
            manualColor,
        } = this.props;

        let classFont = `${textStyle} z-10`;
        let className = `z-10 block border rounded-full overflow-x-hidden group ${
            disable ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`;
        let wrapperClassName =
            "relative flex items-center justify-center w-full h-full";

        if (comingSoon) {
            return (
                <div className={"w-200 h-46 relative" + " " + style}>
                    <IconButton className={textStyle} />
                    <div className="absolute cursor-not-allowed top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                        <p className={classFont}>{text}</p>
                    </div>
                </div>
            );
        }

        if (backgroundColor) className += " " + backgroundColor;

        if (borderColor) className += " " + borderColor;

        if (style) className += " " + style;

        if (wrapperStyle) wrapperClassName += " " + wrapperStyle;

        if (height) className += " " + height;

        if (submit) {
            return (
                <button
                    title={text || title}
                    onClick={this._onPress}
                    type="submit"
                    className={className}
                    style={{
                        backgroundColor: manualColor || null,
                        borderColor: manualColor || null,
                    }}
                >
                    <div className={wrapperClassName}>
                        {icon && icon}
                        {text && <p className={classFont}>{text}</p>}
                        {this._renderAnimation()}
                    </div>
                </button>
            );
        }

        if (url)
            return (
                <a
                    title={text || title}
                    href={url}
                    target={target}
                    onClick={this._onPress}
                    className={className}
                    style={{
                        backgroundColor: manualColor || null,
                        borderColor: manualColor || null,
                    }}
                >
                    <div className={wrapperClassName}>
                        {icon && icon}
                        {text && <p className={classFont}>{text}</p>}
                        {this._renderAnimation()}
                    </div>
                </a>
            );

        if (to)
            return (
                <Link
                    title={text || title}
                    to={to}
                    target={toTarget}
                    onClick={this._onPress}
                    className={className}
                    style={{
                        backgroundColor: manualColor || null,
                        borderColor: manualColor || null,
                    }}
                >
                    <div className={wrapperClassName}>
                        {icon && icon}
                        {text && <p className={classFont}>{text}</p>}
                        {this._renderAnimation()}
                    </div>
                </Link>
            );

        if (href)
            return (
                <a
                    title={text || title}
                    href={href}
                    target={target}
                    onClick={this._onPress}
                    className={className}
                    style={{
                        backgroundColor: manualColor || null,
                        borderColor: manualColor || null,
                    }}
                >
                    <div className={wrapperClassName}>
                        {icon && icon}
                        {text && <p className={classFont}>{text}</p>}
                        {this._renderAnimation()}
                    </div>
                </a>
            );

        return (
            <button
                type="button"
                title={text || title}
                onClick={this._onPress}
                className={className}
                style={{
                    backgroundColor: manualColor || null,
                    borderColor: manualColor || null,
                }}
            >
                <div className={wrapperClassName}>
                    {icon && icon}
                    {text && <p className={classFont}>{text}</p>}
                    {this._renderAnimation()}
                    {this._renderLoading()}
                </div>
            </button>
        );
    }
}

Button.defaultProps = {
    text: null,
    to: null,
    href: null,
    url: null,
    disable: false,
    comingSoon: false,
    style: "",
    wrapperStyle: "",
    backgroundColor: "",
    backgroundColorOver: "bg-blue",
    borderColor: "border-blue",
    height: "h-46",
    textStyle: "font-brown text-17 text-blue",
    submit: false,
    isLoading: false,
    target: "_blank",
};

export default Button;
